import { Injectable } from '@angular/core';
import { DevicePilomat } from '../model/devicePilomat';
import { Observable, of, throwError } from 'rxjs';
import { catchError, map, tap } from 'rxjs/operators';
import { ItemsList } from '../model/itemsList';
import { BaseService } from './base.service';
import { HttpClient } from '@angular/common/http';
import { AngularFireAuth } from '@angular/fire/compat/auth';
import { Log } from '../util/log';
import { DevicePilomatOwerRel } from '../model/devicePilomatOwerRel';
import { LogEvent } from '../model/logEvent';
import { DateHelper } from '../util/dateHelper';
import { DevicePilomatIO } from '../model/devicePilomatIO';
import { EntityId } from '../model/entityId';
import { DevicePilomatIOs } from '../model/devicePilomatIOs';
import { SerialsList } from '../model/serialsList';
import { DeviceState } from '../model/deviceState';
import { AccessLogEvent } from '../model/accessLogEvent';
import { DeviceStateData } from '../model/deviceStateData';
import { DeviceStatesData } from '../model/deviceStatesData';
import { DataLayerManager } from '_node_modules/@agm/core/public-api';
import { environment } from 'src/environments/environment';
import { EntityCount } from '../model/entityCount';
import { GetAccessesApi } from '../model/getAccessesApi';
import { ProgrammedExecution } from '../model/programmedExecution';
import { PeriodicExecution } from '../model/periodicExecution';
import { DevicePilomatActivation } from '../model/devicePilomatActivation';
import { ExecutionsLogEvent } from '../model/ExecutionsLogEvent';
import { Automation } from '../model/automation';

@Injectable({
  providedIn: 'root'
})
export class DeviceService extends BaseService {

  // private devicesList;

  private devicesCache: DevicePilomat[] | null = null;


  private devicesObservable;
  private activatedDevicesObservable;
  private deviceSerialsObservable;
  private unlinkedDevicesObservable;
  private devicesIOsObservable;
  private ownerDevicesObservable;
  private ownerDeviceRelObservable;
  private accessLogObservable;
  private deviceDetailsObservable;
  private logObservable;
  private csvLogObservable;
  private executionsLogObservable;
  private logCountObservable;
  private executionsLogCountObservable;
  private openObservable;
  private otaObservable;
  private rebootObservable;
  private forcedLowObservable;
  private serialsObservable;
  private deviceStatesDataObservable;
  private logAccessesObservable;
  private deviceObservable;
  private AvailableVpnClientsObservable;

  private programmedExecutionObservable;
  private automationObservable;

  private periodicExecutionObservable;

  constructor(http: HttpClient, afAuth: AngularFireAuth) {
    super(http, afAuth);

    Log.debug('DeviceService constructor');
  }

  public getDevice(serial: string): Observable<DevicePilomat> {

    // return this.getDevices().pipe(
    //   (map(elements => elements.find(device => device.serial === serial)))
    // );

    this.deviceObservable = this.getData<ItemsList<DevicePilomat>>('device/' + serial).pipe(
      map((data) => {

        this.deviceObservable = null;

        this.deviceObservable = new DevicePilomat().deserialize(data);

        return this.deviceObservable;
      }
      ))
      .pipe(catchError(err => {
        Log.debug('getDevices error :' + err);
        this.deviceObservable = null;
        return throwError(err);
      }
      ));

    return this.deviceObservable;


  }

  public renewDevices() {

    // this.devicesList = null;
  }

  public getDevices(): Observable<DevicePilomat[]> {

    if (this.devicesCache) {
      Log.debug('getDevices: dati restituiti dalla cache.');
      return of(this.devicesCache);
    }

    if (this.devicesObservable) {

      Log.debug('getDevices data already loading');

      return this.devicesObservable;

    } else {

      // Log.debug('getDevices no data');

      // this.devicesObservable = this.getData<ItemsList<DevicePilomat[]>>('device').pipe(
      //   map((data) => {

      //     this.devicesObservable = null;

      //     const o = Object.create(ItemsList.prototype);
      //     Object.assign(o, data);
      //     o.items = data.items.map(item => new DevicePilomat().deserialize(item));

      //     Log.debug('devices: ' + JSON.stringify(o.items));

      //     return o.items;
      //   }
      //   ))
      //   .pipe(catchError(err => {
      //     Log.debug('getDevices error :' + err);
      //     this.devicesObservable = null;
      //     return throwError(err);
      //   }
      //   ));

      this.devicesObservable = this.getData<ItemsList<DevicePilomat[]>>('device').pipe(
        map(data => {
          const o = Object.create(ItemsList.prototype);
          Object.assign(o, data);
          o.items = data.items.map(item => new DevicePilomat().deserialize(item));
          Log.debug('devices: ' + JSON.stringify(o.items));
          return o.items;
        }),
        // ✅ Usa 'tap' per eseguire un'azione (salvare in cache) senza modificare i dati
        tap(items => {
          this.devicesCache = items;      // Salva i dati nella cache
          this.devicesObservable = null;  // Resetta l'observable in corso
        }),
        catchError(err => {
          Log.debug('getDevices error: ' + err);
          this.devicesObservable = null; // Resetta anche in caso di errore
          return throwError(() => new Error(err));
        })
      );

      return this.devicesObservable;
    }
  }

  public getActivatedDevices(): Observable<DevicePilomatActivation[]> {
    // Log.debug('getDevices no data');

    this.activatedDevicesObservable = this.getData<ItemsList<DevicePilomatActivation[]>>('device/activation').pipe(
      map((data) => {

        this.activatedDevicesObservable = null;

        const o = Object.create(ItemsList.prototype);
        Object.assign(o, data);
        o.items = data.items.map(item => new DevicePilomatActivation().deserialize(item));

        Log.debug('activated devices: ' + JSON.stringify(o.items));

        return o.items;
      }
      ))
      .pipe(catchError(err => {
        Log.debug('getActivatedDevices error :' + err);
        this.activatedDevicesObservable = null;
        return throwError(err);
      }
      ));

    return this.activatedDevicesObservable;
  }

  public getDeviceSerials() {
    if (this.devicesObservable) {
      this.deviceSerialsObservable = [];
      for (let i = 0; i < this.devicesObservable.length(); i++) {
        this.deviceSerialsObservable.push(this.devicesObservable.serial);
      }
    } else {
      this.getDevices().subscribe(data => {
        this.deviceSerialsObservable = [];
        for (let i = 0; i < this.devicesObservable.length(); i++) {
          this.deviceSerialsObservable.push(this.devicesObservable.serial);
        }
      });
    }

    return this.deviceSerialsObservable;
  }

  public getUnlinkedDevices(): Observable<DevicePilomat[]> {

    if (this.unlinkedDevicesObservable) {

      Log.debug('getUnlinkedDevices data already loading');

      return this.unlinkedDevicesObservable;

    } else {

      Log.debug('getUnlinkedDevices no data');

      this.unlinkedDevicesObservable = this.getData<ItemsList<DevicePilomat[]>>('deviceWithoutOwner').pipe(map((data) => {

        this.devicesObservable = null;

        Log.debug('getUnlinkedDevices: ' + JSON.stringify(data));

        const o = Object.create(ItemsList.prototype);
        Object.assign(o, data);
        o.items = data.items.map(item => new DevicePilomat().deserialize(item));

        Log.debug('getUnlinkedDevices: ' + JSON.stringify(o.items));

        return o.items;
      }
      ))
        .pipe(catchError(err => {
          Log.debug('getDevices error :' + err);
          this.unlinkedDevicesObservable = null;
          return throwError(err);
        }
        ));
      return this.unlinkedDevicesObservable;
    }
  }


  public getOwnerDevices(ownerUid: string): Observable<DevicePilomat[]> {

    if (this.ownerDevicesObservable) {

      Log.debug('getOwnerDevices data already loading');

      return this.ownerDevicesObservable;

    } else {

      this.ownerDevicesObservable = this.getData<ItemsList<DevicePilomat[]>>('user/' + ownerUid + '/owner/device').pipe(
        map((data) => {

          this.ownerDevicesObservable = null;

          Log.debug('getOwnerDevices: ' + JSON.stringify(data));

          const o = Object.create(ItemsList.prototype);
          Object.assign(o, data);
          o.items = data.items.map(item => new DevicePilomat().deserialize(item));

          Log.debug('owner devices: ' + JSON.stringify(o.items));

          return o.items;
        }
        ))
        .pipe(catchError(err => {
          Log.debug('getOwnerDevices error :' + err);
          this.ownerDevicesObservable = null;
          return throwError(err);
        }
        ));

      return this.ownerDevicesObservable;
    }
  }

  public getDeviceIOs(serial: string): Observable<DevicePilomatIO[]> {

    // if (this.devicesIOsObservable) {

    //   Log.debug('getDeviceIOs data already loading');

    //   return this.devicesIOsObservable;

    // } else {

    this.devicesIOsObservable = this.getData<ItemsList<DevicePilomatIO[]>>('device/' + serial + '/io').pipe(
      map((data) => {

        this.devicesIOsObservable = null;

        // Log.debug('getDeviceIOs: ' + JSON.stringify(data));

        const o = Object.create(ItemsList.prototype);
        Object.assign(o, data);
        o.items = data.items.map(item => new DevicePilomatIO().deserialize(item));

        // Log.debug('device ios: ' + JSON.stringify(o.items));

        return o.items;
      }
      ))
      .pipe(catchError(err => {
        Log.debug('getDeviceIOs error :' + err);
        this.devicesIOsObservable = null;
        return throwError(err);
      }
      ));

    return this.devicesIOsObservable;
    // }
  }

  public forceIoUpdate(serial: string): any {
    let response;
    response = this.postData<EntityId>('device/' + serial + '/ios/update', null).pipe(
      map((data) => {

        Log.debug('IOs updated: ' + JSON.stringify(data));

        return data;
      }
      ));
    return response;
  }



  // POST move/{originSerial}/to/{destinationSerial}/owner/{ownerUid}/permissions
  public migrateDevice(originSerial: string, destinationSerial: string, ownerUid: string): any {
    let response;
    response = this.postData<EntityId>('move/' + originSerial + '/to/' + destinationSerial + '/owner/' + ownerUid + '/permissions', null).pipe(
      map((data) => {

        Log.debug('migrateDevice: ' + JSON.stringify(data));

        return data;
      }
      ));
    return response;
  }

  public createUpdateDeviceIOs(deviceIOs: DevicePilomatIOs, serial: string): Observable<EntityId> {

    this.ownerDeviceRelObservable = this.postData<EntityId>('device/' + serial + '/ios', deviceIOs).pipe(
      map((data) => {

        this.ownerDeviceRelObservable = null;

        Log.debug('createUpdateDeviceIO: ' + JSON.stringify(data));

        let entity = Object.create(EntityId.prototype);
        entity.deserialize(data);

        Log.debug('createUpdateDeviceIO: ' + JSON.stringify(entity));

        return entity;
      }
      ));
    return this.ownerDeviceRelObservable;
  }

  public updateDeviceDetails(device: DevicePilomat, serial: string): any {
    let response;
    response = this.postData<EntityId>('device/' + serial, device).pipe(
      map((data) => {
        // response = data;
        Log.debug('updateDeviceDetails: ' + JSON.stringify(data));;
        return data;
      }
      ));
    return response;
  }


  public linkDeviceToOwner(serial: string, ownerUid: string): Observable<DevicePilomatOwerRel> {

    this.ownerDeviceRelObservable = this.postData<DevicePilomatOwerRel>('device/' + serial + '/user/owner/' + ownerUid, null).pipe(
      map((data) => {

        this.ownerDeviceRelObservable = null;

        Log.debug('linkDeviceToOwner: ' + JSON.stringify(data));

        let owner = Object.create(DevicePilomatOwerRel.prototype);
        owner.deserialize(data);

        Log.debug('DevicePilomatOwerRel: ' + JSON.stringify(owner));

        return owner;
      }
      ));
    return this.ownerDeviceRelObservable;
  }

  public unlinkDeviceFromOwner(serial: string, ownerUid: string): Observable<EntityId> {
    let response = this.deleteData<EntityId>('device/' + serial + '/user/owner/' + ownerUid).pipe(
      map((data) => {
        Log.debug('unlinkDeviceFromOwner: ' + JSON.stringify(data));
        return data;
      }
      ));
    return response;
  }

  public getLog(serial: string): Observable<LogEvent[]> {

    if (this.logObservable) {

      Log.debug('getLog data already loading');

      return this.logObservable;

    } else {

      Log.debug('getLog no data');

      this.logObservable = this.getData<ItemsList<LogEvent[]>>('log/' + serial).pipe(
        map((data) => {

          this.logObservable = null;

          //Log.debug('getLog: ' + JSON.stringify(data));

          const o = Object.create(ItemsList.prototype);
          Object.assign(o, data);
          o.items = data.items.map(item => new LogEvent().deserialize(item));

          //Log.debug('log: ' + JSON.stringify(o.items));

          return o.items;
        }
        ))
        .pipe(catchError(err => {
          Log.debug('getLog error :' + err);
          this.logObservable = null;
          return throwError(err);
        }
        ));

      return this.logObservable;
    }
  }

  public getDeviceDetails(serial: string) {

    this.deviceDetailsObservable = this.getData<ItemsList<any[]>>('device/' + serial).pipe(
      map((data) => {

        this.deviceDetailsObservable = null;

        //Log.debug('getLog: ' + JSON.stringify(data));

        const o = Object.create(ItemsList.prototype);
        Object.assign(o, data);
        o.items = data.items.map(item => new LogEvent().deserialize(item));

        //Log.debug('log: ' + JSON.stringify(o.items));

        return o.items;
      }
      ))
      .pipe(catchError(err => {

        Log.debug('getDeviceDetails error :' + err);
        this.deviceDetailsObservable = null;
        return throwError(err);
      }
      ));

    return this.logObservable;
  }

  public getAccessLogWithDate(deviceSerial: string, from: string, to: string, page: number): Observable<AccessLogEvent[]> {

    if (this.accessLogObservable) {

      Log.debug('getAccessLogWithDate data already loading');

      return this.accessLogObservable;

    } else {


      let getModelgetAccessLogWithDate = new GetAccessesApi().deserialize({ deviceSerial, from, to });

      Log.debug("\n\n\tgetAccessLogWithDate dates: ");
      Log.debug("\nfrom");
      Log.debug(from);

      Log.debug("\nto");
      Log.debug(to);

      Log.debug("\n\n\tgetAccessLogWithDate model: ");
      Log.debug(getModelgetAccessLogWithDate);

      Log.debug('getAccessLogWithDate no data');
      // https://onecontrol-cloud-pilomat.appspot.com/_ah/api/webAdmin/v1/
      this.accessLogObservable = this.postData<ItemsList<AccessLogEvent[]>>('getAccesses/page/' + page, getModelgetAccessLogWithDate).pipe(
        // <EntityId>("userOwnerRel/" + ownerUid, stringToPost).pipe(
        map((data) => {

          this.accessLogObservable = null;

          //Log.debug('getLog: ' + JSON.stringify(data));

          const o = Object.create(ItemsList.prototype);
          Object.assign(o, data);
          o.items = data.items.map(item => new AccessLogEvent().deserialize(item));

          //Log.debug('log: ' + JSON.stringify(o.items));

          return o.items;
        }
        ))
        .pipe(catchError(err => {
          Log.debug('getAccessLogWithDate error :' + err);
          this.accessLogObservable = null;
          return throwError(err);
        }
        ));

      return this.accessLogObservable;
    }
  }

  public getLogWithDate(serial: string, fromDate: string, toDate: string, page: number): Observable<LogEvent[]> {


    if (this.logObservable) {

      Log.debug('getLog data already loading');

      return this.logObservable;

    } else {

      Log.debug('getLog no data');
      // https://onecontrol-cloud-pilomat.appspot.com/_ah/api/webAdmin/v1/log/{serial}/{mindate}/{maxDate}/page/{page}
      this.logObservable = this.getData<any>('log/' + serial + "/" + fromDate + "/" + toDate + "/page/" + page).pipe(
        map((data) => {


          // data.items[i].date: 
          // device.service.ts:523 2024-05-13 03:56:51Z
          // device.service.ts:513 {"id":92,"sender":"2300052","type":"canbusErr","data":{"err":"get-state"}} }
          // device.service.ts:515 {"id":92,"sender":"2300052","type":"canbusErr","data":{"err":"get-state"}}}
          // device.service.ts:519 i = 84
          // device.service.ts:520 data.items[i].type: 
          // device.service.ts:521 canbusErr
          // device.service.ts:522 data.items[i].date: 
          // device.service.ts:523 2024-05-13 03:56:54Z
          // log.ts:8 getLogWithDate error :SyntaxError: Unexpected non-whitespace character after JSON at position 74 (line 1 column 75)
          // log.ts:8 hideLoading

          this.logObservable = null;
          for (let i = 0; i < data.items.length; i++) {

            if (data.items[i].data.includes("\u0000")) {
              data.items[i].data = data.items[i].data.replaceAll("\u0000", "");
            }

            if (data.items[i].data != "null") {
              try {
                if (JSON.parse(data.items[i].data).type) {
                  // if (JSON.parse(data.items[i].data).type.startsWith("sta")) {
                  //   data.items.splice(i, 1);
                  //   i--;
                  // }
                  if (JSON.parse(data.items[i].data).type == "deviceInfo") {
                    data.items.splice(i, 1);
                    i--;
                  }
                  if (data.items[i].type == "httpErr") {
                    data.items.splice(i, 1);
                    i--;
                  }
                }
              } catch (e: unknown) {
                Log.debug("\n\n\nERROR");
                Log.debug(e);

              }
            }

          }

          const o = Object.create(ItemsList.prototype);
          Object.assign(o, data);
          o.items = data.items.map(item => new LogEvent().deserialize(item));

          return o.items;
        }
        ))
        .pipe(catchError(err => {
          Log.debug('getLogWithDate error :' + err);
          this.logObservable = null;
          return throwError(err);
        }
        ));

      return this.logObservable;
    }
  }

  public downloadLogCsv(serial: string, fromDate: string, toDate: string): Observable<string> {


    // if (this.csvLogObservable) {

    //   Log.debug('getLog data already loading');

    //   return this.csvLogObservable;

    // } else {

    Log.debug('getLog no data');
    // GET log/csv/{serial}/{mindate}/{maxDate}
    this.csvLogObservable = this.getData<any>('log/csv/' + serial + "/" + fromDate + "/" + toDate).pipe(
      map((csvUrl) => {

        Log.debug("\n\nIn service, csvUrl got is:");

        Log.debug(csvUrl);

        return csvUrl.data;
      }
      ))
      .pipe(catchError(err => {
        Log.debug('downloadLogCsv error :' + err);
        this.csvLogObservable = null;
        return throwError(err);
      }
      ));

    return this.csvLogObservable;
    // }
  }

  public getExecutionsLogWithDate(serial: string, fromDate: string, toDate: string, page: number): Observable<ExecutionsLogEvent[]> {


    if (this.executionsLogObservable) {

      Log.debug('getExecutionsLogWithDate data already loading');

      return this.executionsLogObservable;

    } else {

      Log.debug('getExecutionsLogWithDate no data');
      // GET /webAdmin/v1/executionsLogs/serial/{serial}/{mindate}/{maxDate}/page/{page}
      this.executionsLogObservable = this.getData<any>('executionsLogs/serial/' + serial + "/" + fromDate + "/" + toDate + "/page/" + page).pipe(
        map((data) => {

          this.executionsLogObservable = null;

          const o = Object.create(ItemsList.prototype);
          Object.assign(o, data);
          o.items = data.items.map(item => new ExecutionsLogEvent().deserialize(item));

          return o.items;
        }
        ))
        .pipe(catchError(err => {
          Log.debug('getExecutionsLogWithDate error :' + err);
          this.executionsLogObservable = null;
          return throwError(err);
        }
        ));

      return this.executionsLogObservable;
    }
  }

  getLogCount(serial: string, fromDate: string, toDate: string): Observable<EntityCount> {

    if (this.logCountObservable) {
      Log.debug('getLogCount data already loading');
      return this.logCountObservable;

    } else {

      // https://onecontrol-cloud-pilomat.appspot.com/_ah/api/webAdmin/v1/log/{serial}/{mindate}/{maxDate}/count

      this.logCountObservable = this.getData<EntityCount>('log/' + serial + "/" + fromDate + "/" + toDate + "/count").pipe(
        map((data) => {
          Log.debug("Log count: " + JSON.stringify(data));

          this.logCountObservable = null;

          let entityCount = Object.create(EntityCount.prototype);
          entityCount.deserialize(data);

          return entityCount;
        }
        ))
        .pipe(catchError(err => {
          Log.debug('getLogCount error :' + err);
          this.logCountObservable = null;
          return throwError(err);
        }
        ));
    }
    return this.logCountObservable;
  }

  getExecutionsLogCount(serial: string, fromDate: string, toDate: string): Observable<EntityCount> {

    if (this.executionsLogCountObservable) {
      Log.debug('getExecutionsLogCount data already loading');
      return this.executionsLogCountObservable;

    } else {

      //GET /webAdmin/v1/executionsLogs/serial/{serial}/{mindate}/{maxDate}/count
      this.executionsLogCountObservable = this.getData<EntityCount>('executionsLogs/serial/' + serial + "/" + fromDate + "/" + toDate + "/count").pipe(
        map((data) => {
          Log.debug("getExecutionsLogCount: " + JSON.stringify(data));

          this.executionsLogCountObservable = null;

          let entityCount = Object.create(EntityCount.prototype);
          entityCount.deserialize(data);

          return entityCount;
        }
        ))
        .pipe(catchError(err => {
          Log.debug('getExecutionsLogCount error :' + err);
          this.executionsLogCountObservable = null;
          return throwError(err);
        }
        ));
    }
    return this.executionsLogCountObservable;
  }

  getAccessesCount(deviceSerial: string, from: string, to: string): Observable<EntityCount> {

    if (this.logAccessesObservable) {
      Log.debug('getAccessesCount data already loading');
      return this.logAccessesObservable;

    } else {



      let getModel = new GetAccessesApi().deserialize({ deviceSerial, from, to });

      this.logAccessesObservable = this.postData<EntityCount>("getAccesses/count", getModel).pipe(
        map((data) => {
          Log.debug("Log count: " + JSON.stringify(data));

          this.logAccessesObservable = null;

          let entityCount = Object.create(EntityCount.prototype);
          entityCount.deserialize(data);

          return entityCount;
        }
        ))
        .pipe(catchError(err => {
          Log.debug('getAccessesCount error :' + err);
          this.logAccessesObservable = null;
          return throwError(err);
        }
        ));
    }
    return this.logAccessesObservable;
  }

  public sendOpenCommand(serial: string): Observable<boolean> {

    if (this.openObservable) {

      Log.debug('open cmd already loading');

      return this.openObservable;

    } else {

      // device/{serial}/{action}/open

      this.openObservable = this.postData<EntityId>('device/' + serial + '/0/open', null).pipe(
        map((data) => {

          this.openObservable = null;

          //Log.debug('open cmd: ' + JSON.stringify(data));

          let entity = Object.create(EntityId.prototype);
          entity.deserialize(data);

          //Log.debug('open cmd: ' + JSON.stringify(o.items));

          return true;
        }
        ))
        .pipe(catchError(err => {
          Log.debug('sendOpenCommand error :' + err);
          this.openObservable = null;
          return throwError(err);
        }
        ));

      return this.openObservable;
    }
  }

  public sendForcedLowCommand(serial: string, state: boolean): Observable<boolean> {

    if (this.forcedLowObservable) {

      Log.debug('forcedLowObservablealready loading');

      return this.forcedLowObservable;

    } else {

      // API POST /webAdmin/v1/device/{serial}/forcelow/{active}

      this.forcedLowObservable = this.postData<EntityId>('device/' + serial + '/forcelow/' + state, null).pipe(
        map((data) => {

          this.forcedLowObservable = null;

          //Log.debug('open cmd: ' + JSON.stringify(data));

          let entity = Object.create(EntityId.prototype);
          entity.deserialize(data);

          //Log.debug('open cmd: ' + JSON.stringify(o.items));

          return true;
        }
        ))
        .pipe(catchError(err => {
          Log.debug('sendOpenCommand error :' + err);
          this.forcedLowObservable = null;
          return throwError(err);
        }
        ));

      return this.forcedLowObservable;
    }
  }

  public sendCloseCommand(serial: string): Observable<boolean> {

    if (this.openObservable) {

      Log.debug('open cmd already loading');

      return this.openObservable;

    } else {

      // device/{serial}/{action}/open

      this.openObservable = this.postData<EntityId>('device/' + serial + '/0/close', null).pipe(
        map((data) => {

          this.openObservable = null;

          //Log.debug('open cmd: ' + JSON.stringify(data));

          let entity = Object.create(EntityId.prototype);
          entity.deserialize(data);

          //Log.debug('open cmd: ' + JSON.stringify(o.items));

          return true;
        }
        ))
        .pipe(catchError(err => {
          Log.debug('sendOpenCommand error :' + err);
          this.openObservable = null;
          return throwError(err);
        }
        ));

      return this.openObservable;
    }
  }

  public sendSBSCommand(serial: string): Observable<boolean> {

    if (this.openObservable) {

      Log.debug('open cmd already loading');

      return this.openObservable;

    } else {

      // device/{serial}/{action}/open

      this.openObservable = this.postData<EntityId>('device/' + serial + '/0/sbs', null).pipe(
        map((data) => {

          this.openObservable = null;

          //Log.debug('open cmd: ' + JSON.stringify(data));

          let entity = Object.create(EntityId.prototype);
          entity.deserialize(data);

          //Log.debug('open cmd: ' + JSON.stringify(o.items));

          return true;
        }
        ))
        .pipe(catchError(err => {
          Log.debug('sendOpenCommand error :' + err);
          this.openObservable = null;
          return throwError(err);
        }
        ));

      return this.openObservable;
    }
  }

  public sendOTACommand(serial: string): Observable<boolean> {

    if (this.otaObservable) {

      Log.debug('open cmd already loading');

      return this.otaObservable;

    } else {

      // "device/{serial}/ota"
      this.otaObservable = this.postData<EntityId>('device/' + serial + '/ota', null).pipe(
        map((data) => {

          this.otaObservable = null;

          //Log.debug('open cmd: ' + JSON.stringify(data));

          let entity = Object.create(EntityId.prototype);
          entity.deserialize(data);

          //Log.debug('open cmd: ' + JSON.stringify(o.items));

          return true;
        }
        ))
        .pipe(catchError(err => {
          Log.debug('ota command error :' + err);
          this.otaObservable = null;
          return throwError(err);
        }
        ));

      return this.otaObservable;
    }
  }

  public sendRebootCommand(serial: string): Observable<boolean> {

    if (this.rebootObservable) {

      Log.debug('open cmd already loading');

      return this.rebootObservable;

    } else {

      // "device/{serial}/ota"
      this.rebootObservable = this.postData<EntityId>('device/' + serial + '/reboot', null).pipe(
        map((data) => {

          this.rebootObservable = null;

          //Log.debug('open cmd: ' + JSON.stringify(data));

          let entity = Object.create(EntityId.prototype);
          entity.deserialize(data);

          //Log.debug('open cmd: ' + JSON.stringify(o.items));

          return true;
        }
        ))
        .pipe(catchError(err => {
          Log.debug('ota command error :' + err);
          this.rebootObservable = null;
          return throwError(err);
        }
        ));

      return this.rebootObservable;
    }
  }

  public getLogBetweenDates(serial: string, minDate: Date, maxDate: Date): Observable<LogEvent[]> {

    if (this.logObservable) {

      Log.debug('getLog data already loading');

      return this.logObservable;

    } else {

      Log.debug('getLog no data');

      let minDateStr = DateHelper.formatDateRFC3339(minDate);
      let maxDateStr = DateHelper.formatDateRFC3339(maxDate);

      this.logObservable = this.getData<ItemsList<LogEvent[]>>('log/' + serial + '/' + minDateStr + '/' + maxDateStr + '').pipe(
        map((data) => {

          this.logObservable = null;

          //Log.debug('getLog: ' + JSON.stringify(data));

          const o = Object.create(ItemsList.prototype);
          Object.assign(o, data);
          o.items = data.items.map(item => new LogEvent().deserialize(item));

          //Log.debug('log: ' + JSON.stringify(o.items));

          return o.items;
        }
        ))
        .pipe(catchError(err => {
          Log.debug('getLogBetweenDates error :' + err);
          this.logObservable = null;
          return throwError(err);
        }
        ));

      return this.logObservable;
    }
  }

  getDevicesState(serials: SerialsList): Observable<DeviceState[]> {

    if (this.serialsObservable) {

      // Log.debug('getDevicesState data already loading');

      return this.serialsObservable;

    } else {

      // Log.debug('getDevicesState no data');

      this.serialsObservable = this.postData<ItemsList<DeviceState[]>>('devices/state', serials).pipe(
        map((data) => {

          // Log.debug("getDevicesState data: " + JSON.stringify(data));

          const o = Object.create(ItemsList.prototype);
          Object.assign(o, data);
          o.items = data.items.map(item => new DeviceState().deserialize(item));

          return data.items;
        }
        ))
        .pipe(catchError(err => {
          Log.debug('getDevicesState error :' + err);
          this.serialsObservable = null;
          return throwError(err);
        }
        ));
      return this.serialsObservable;
    }
  }

  getDeviceState(serial: String): Observable<DeviceState> {

    return this.getData<DeviceState>('device/' + serial + "/state").pipe(
      map((data) => {
        Log.debug("getDeviceState data: " + JSON.stringify(data));

        let deviceState = Object.create(DeviceState.prototype);
        deviceState.deserialize(data);

        return deviceState;
      }
      ));
    // .pipe(catchError(err => {
    //   Log.debug('getDeviceState error :' + err);
    //   return throwError(err);
    // }
    // ));
  }

  getDeviceStateData(serial: string): Observable<DeviceStateData[]> {
    // https://onecontrol-cloud-pilomat.appspot.com/_ah/api/webAdmin/v1/device/{serial}/states
    return this.getData<ItemsList<DeviceStateData[]>>('device/' + serial + "/states").pipe(
      map((data) => {
        // Log.debug("getDeviceStateData: " + JSON.stringify(data));

        this.deviceStatesDataObservable = null;

        const o = Object.create(ItemsList.prototype);
        Object.assign(o, data);
        o.items = data.items.map(item => new DeviceStateData().deserialize(item));
        return o.items;

      }
      ))
      .pipe(catchError(err => {
        Log.debug('getDeviceStateData error :' + err);
        this.deviceStatesDataObservable = null;
        return throwError(err);
      }
      ));
  }

  getCoordinatesOfLocation(location: string): Observable<any> {

    let response;
    location = location.replace(/ /g, "+");
    Log.debug("location formatted: " + location);
    response = this.getUrl("https://maps.googleapis.com/maps/api/geocode/json?address=" + location + "&key=" + environment.onecontrol.apiKey).pipe(
      map((data) => {
        Log.debug("getCoordinatesOfLocation: " + JSON.stringify(data));
        return data;
      }
      ));

    return response;
  }

  // GET /webAdmin/v1/device/{serial}/programmedExecution
  public getProgrammedExecution(serial: string): Observable<ProgrammedExecution[]> {
    this.programmedExecutionObservable = this.getData<any>("device/" + serial + "/programmedExecution").pipe(
      map((data) => {
        var executionsList: ProgrammedExecution[] = [];

        this.programmedExecutionObservable = null;

        for (let i = 0; i < data.items.length; i++) {

          let execution: ProgrammedExecution = Object.create(ProgrammedExecution.prototype);
          execution.deserialize(data.items[i]);

          executionsList.push(execution);
        }
        return executionsList;
      }
      ))
      .pipe(catchError(err => {
        Log.debug('getProgrammedExecution: ' + err);
        this.programmedExecutionObservable = null;
        return throwError(err);
      }
      ));

    return this.programmedExecutionObservable;
  }

  // get /webAdmin/v1/owner/{ownerUid}/automation
  public getAutomations(ownerUid: string): Observable<Automation[]> {
    this.automationObservable = this.getData<any>("owner/" + ownerUid + "/automation").pipe(
      map((data) => {
        var executionsList: Automation[] = [];

        this.automationObservable = null;

        for (let i = 0; i < data.items.length; i++) {

          let execution: Automation = Object.create(Automation.prototype);
          execution.deserialize(data.items[i]);

          executionsList.push(execution);
        }
        return executionsList;
      }
      ))
      .pipe(catchError(err => {
        Log.debug('getAutomations: ' + err);
        this.automationObservable = null;
        return throwError(err);
      }
      ));

    return this.automationObservable;
  }


  // POST /webAdmin/v1/device/{serial}/programmedExecution
  public updateProgrammedExecution(serial: string, updatedExecution: ProgrammedExecution): Observable<EntityId> {
    let response = this.postData<EntityId>("device/" + serial + "/programmedExecution", JSON.stringify(updatedExecution)).pipe(
      map((data) => {
        let entity = Object.create(EntityId.prototype);
        entity.deserialize(data);
        return entity;
      }
      )).pipe(catchError(err => {
        Log.debug('updateUserPermissions error :' + err);
        return throwError(err);
      }
      ));
    return response;
  }

  // DELETE /webAdmin/v1/device/{serial}/programmedExecution/{id}
  public deleteProgrammedExecution(serial: string, id: number): Observable<EntityId> {
    let response = this.deleteData<EntityId>('device/' + serial + '/programmedExecution/' + id).pipe(
      map((data) => {
        Log.debug('deleteProgrammedExecution: ' + JSON.stringify(data));
        return data;
      }
      ));
    return response;
  }


  //GET /webAdmin/v1/device/{serial}/periodicExecution
  public getPeriodicExecution(serial: string): Observable<PeriodicExecution[]> {
    this.periodicExecutionObservable = this.getData<any>("device/" + serial + "/periodicExecution").pipe(
      map((data) => {
        var executionsList: PeriodicExecution[] = [];

        this.periodicExecutionObservable = null;

        for (let i = 0; i < data.items.length; i++) {

          let execution: PeriodicExecution = Object.create(PeriodicExecution.prototype);
          execution.deserialize(data.items[i]);

          executionsList.push(execution);
        }
        return executionsList;
      }
      ))
      .pipe(catchError(err => {
        Log.debug('getPeriodicExecution: ' + err);
        this.periodicExecutionObservable = null;
        return throwError(err);
      }
      ));

    return this.periodicExecutionObservable;
  }

  // POST /webAdmin/v1/device/{serial}/periodicExecution
  public updatePeriodicExecution(serial: string, updatedExecution: PeriodicExecution): Observable<EntityId> {
    let response = this.postData<EntityId>("device/" + serial + "/periodicExecution", JSON.stringify(updatedExecution)).pipe(
      map((data) => {
        let entity = Object.create(EntityId.prototype);
        entity.deserialize(data);
        return entity;
      }
      )).pipe(catchError(err => {
        Log.debug('updatePeriodicExecution error :' + err);
        return throwError(err);
      }
      ));
    return response;
  }

  // DELETE /webAdmin/v1/device/{serial}/periodicExecution/{id}
  public deletePeriodicExecution(serial: string, id: number): Observable<EntityId> {
    let response = this.deleteData<EntityId>('device/' + serial + '/periodicExecution/' + id).pipe(
      map((data) => {
        Log.debug('deletePeriodicExecution: ' + JSON.stringify(data));
        return data;
      }
      ));
    return response;
  }


  // post /webAdmin/v1/device/{serial}/automation
  public createAutomation(serial: string, automation: Automation): Observable<EntityId> {
    let response = this.postData<EntityId>("device/" + serial + "/automation", JSON.stringify(automation)).pipe(
      map((data) => {
        let entity = Object.create(EntityId.prototype);
        entity.deserialize(data);
        return entity;
      }
      )).pipe(catchError(err => {
        Log.debug('createAutomation error :' + err);
        return throwError(err);
      }
      ));
    return response;
  }


  // delete /webAdmin/v1/device/{serial}/automation/{id}
  public deleteAutomation(serial: string, id: number): Observable<EntityId> {
    let response = this.deleteData<EntityId>('device/' + serial + '/automation/' + id).pipe(
      map((data) => {
        Log.debug('deleteAutomation: ' + JSON.stringify(data));
        return data;
      }
      ));
    return response;
  }

  public getIsVpnConnected(routerSerial): Observable<any> {

    //cors error
    // this.AvailableVpnClientsObservable = this.getDataApi<any>("./assets/api/getAvailableClients.php").pipe(
    this.AvailableVpnClientsObservable = this.getDataApi<any>("https://pilomat.1control.eu/api/getConnectedClients.php?routerSerial=" + routerSerial).pipe(
      map((data) => {
        return data;
      }
      ))
      .pipe(catchError(err => {
        Log.debug('getAvailableVpnClients: ' + err);
        this.AvailableVpnClientsObservable = null;

        if (err.error.code == 404) {
          Log.debug("No VPN connected");
          return null;
        } else if (err.error.code == 401) {
          Log.debug("Cors error");
          return null;
        } else {
          return throwError(err);
        }
      }
      ));

    return this.AvailableVpnClientsObservable;
  }

  public getIsVpnCreated(routerSerial): Observable<any> {

    //cors error
    // this.AvailableVpnClientsObservable = this.getDataApi<any>("./assets/api/getAvailableClients.php").pipe(
    this.AvailableVpnClientsObservable = this.getDataApi<any>("https://pilomat.1control.eu/api/getAvailableClients.php?routerSerial=" + routerSerial).pipe(
      map((data) => {
        return data;
      }
      ))
      .pipe(catchError(err => {
        Log.debug('getAvailableVpnClients: ' + err);
        this.AvailableVpnClientsObservable = null;
        return throwError(err);
      }
      ));

    return this.AvailableVpnClientsObservable;
  }



}
